import api from '../utils/apiConfig';

// Patient API service
export const patientAPI = {
  // Get all patients with pagination and filters
  getPatients: async (params = {}) => {
    const response = await api.get('/patients', { 
      params,
      headers: { 'X-Clinic-Scope': 'all' }
    });
    return response.data;
  },

  // Get a single patient by ID
  getPatient: async (id) => {
    const response = await api.get(`/patients/${id}`);
    return response.data;
  },

  // Create a new patient
  createPatient: async (patientData) => {
    const response = await api.post('/patients', patientData);
    return response.data;
  },

  // Update an existing patient
  updatePatient: async (id, patientData) => {
    const response = await api.put(`/patients/${id}`, patientData);
    return response.data;
  },

  // Delete a patient
  deletePatient: async (id) => {
    const response = await api.delete(`/patients/${id}`);
    return response.data;
  },

  // Search patients
  searchPatients: async (searchTerm) => {
    const response = await api.get('/patients', { 
      params: { search: searchTerm, limit: 50 } 
    });
    return response.data;
  },

  // Pipeline board
  getPipeline: async (params = {}) => {
    const response = await api.get('/patients/pipeline', { params });
    return response.data;
  },

  // Pipeline analytics
  getPipelineAnalytics: async () => {
    const response = await api.get('/patients/pipeline-analytics');
    return response.data;
  },

  // Update pipeline stage
  updatePipelineStage: async (id, stage) => {
    const response = await api.put(`/patients/${id}/pipeline-stage`, { stage });
    return response.data;
  },

  // Update pipeline outcome (open/won/lost)
  updatePipelineOutcome: async (id, payload) => {
    const response = await api.put(`/patients/${id}/pipeline-outcome`, payload);
    return response.data;
  }
};
